import Error from '.Error';
import TypeError from '.TypeError';
import SyntaxError from '.SyntaxError';
import test from '.RegExp.prototype.test';

import * as is from './is';
import * as TOKEN from './TOKEN';
import Layer, { protect } from './Layer';
import Url, { newUrl } from './Url';
import Parenthesis from './Parenthesis';

const needCollect = /*#__PURE__*/test.bind(/^(?:(?:-[a-z][a-z\d]*-)?animation(?:-name)?)$/i);

export class Name extends Layer       {
	
	_literal         = '';
	get literal () { return this._literal; }
	set literal (value) {
		if ( TOKEN.notKeyframes(value) ) { throw SyntaxError(`“${value}”无法作为 animation-name`); }
		this._literal = value;
	}
	
	constructor (literal        ) {
		super();
		TOKEN.currentLayer && ( TOKEN.collection_animation[TOKEN.collection_animation.length] = this );
		this.literal = literal;
		return this;
	}
	
	[TOKEN.consume] (          )        { throw TypeError(`name[consume]`); }
	
	[Symbol.toPrimitive] (          ) {
		return this._literal;
	}
	
	* [Symbol.iterator] (          ) { throw TypeError(`beautify name`); }
	
	                                 
	
	static default = protect(this);
	
}

class Property extends Layer                {
	
	get [Symbol.toStringTag] () { return 'Property'; }
	
	         nameLiteral        ;
	        _colon          = false;
	        _comma          = true;
	
	constructor (nameLiteral        ) {
		super();
		this.nameLiteral = nameLiteral;
		return this;
	}
	
	[TOKEN.consume] (              ) {
		if ( this._colon ) {
			switch ( TOKEN.type ) {
				case TOKEN.ident:
					if ( !this._comma ) { break; }
					this.newItem = TOKEN.notKeyframes(TOKEN.literal) ? TOKEN.literal : new Name(TOKEN.literal);
					this._comma = false;
					return this;
				case TOKEN.string:
					if ( !this._comma ) { break; }
					this.newItem = new Name(TOKEN.literal);
					this._comma = false;
					return this;
				case ',':
					if ( this._comma ) { break; }
					this._comma = true;
					return this;
				case ';':
					if ( this._comma ) { break; }
					return this[TOKEN.parent];
				case '}':
					if ( this._comma ) { break; }
					return this[TOKEN.parent][TOKEN.parent][TOKEN.parent];
				case TOKEN.whitespace:
				case TOKEN.comment:
					return this;
			}
		}
		else {
			switch ( TOKEN.type ) {
				case ':':
					this._colon = true;
					return this;
				case TOKEN.whitespace:
				case TOKEN.comment:
					return this;
			}
		}
		return null;
	}
	
	[Symbol.toPrimitive] (              ) {
		return `${this.nameLiteral}:${this.join(',')};`;
	}
	
	* [Symbol.iterator] (              )                                {
		yield `${this.nameLiteral}: ${this.join(', ')};`;
	}
	
	                                                     
	
	static default = protect(this);
	
}

export default class Declaration extends Layer                             {// property or descriptor
	
	get [Symbol.toStringTag] () { return 'Declaration'; }
	
	         nameLiteral         ;
	        _colon          = false;
	
	constructor (nameLiteral        ) {
		if ( needCollect(nameLiteral) ) {
			if ( nameLiteral[nameLiteral.length - 5]==='-' ) { return new Property(nameLiteral)       ; }
			throw Error(`请用 animation-* 替代 animation`);
		}
		super();
		this.nameLiteral = nameLiteral;
		return this;
	}
	
	[TOKEN.consume] (                 ) {
		if ( this._colon ) {
			switch ( TOKEN.type ) {
				case ';': {
					const { lastItem } = this;
					( lastItem===' ' || lastItem==='/**/' ) && --this.length;
					if ( !this.length ) { break; }
					return this[TOKEN.parent];
				}
				case '}': {
					const { lastItem } = this;
					( lastItem===' ' || lastItem==='/**/' ) && --this.length;
					if ( !this.length ) { break; }
					return this[TOKEN.parent] [TOKEN.parent] [TOKEN.parent];
				}
				case TOKEN.function_:
					return this.newItem = new ( is.url_ (TOKEN.literal) ? Url : Parenthesis )(TOKEN.literal.slice(0, -1));
				case '?':
				case '/':
				case '-':
				case '+':
				case ',':
				case '*':
				case '!':
				case TOKEN.ident:
				case TOKEN.hash:
				case TOKEN.string:
				case TOKEN.number:
				case TOKEN.dimension:
				case TOKEN.percentage:
					this.newItem = TOKEN.literal;
					return this;
				case TOKEN.url:
					if ( TOKEN.literal[3]==='(' ) { return newUrl(this); }
					break;
				case TOKEN.whitespace:
					this.length && ( this.newItem = ' ' );
					return this;
				case TOKEN.comment:
					this.length && ( this.newItem = '/**/' );
					return this;
			}
		}
		else {
			switch ( TOKEN.type ) {
				case ':':
					this._colon = true;
					return this;
				case TOKEN.whitespace:
				case TOKEN.comment:
					return this;
			}
		}
		return null;
	}
	
	[Symbol.toPrimitive] (                 ) {
		return `${this.nameLiteral}:${this.join('')};`;
	}
	
	* [Symbol.iterator] (                 )                                {
		yield `${this.nameLiteral}: ${this.join('')};`;
	}
	
	                                             
	
	static default = protect(this);
	
};

                                           
                                           